import {
    RETAILER_CHECKOUT_CONVERT,
    RETAILER_ORDER_PAY,
} from '@marketplace/graphql/checkout.js'

export default {
    methods: {
        convertToOrder() {
            this.$apollo
                .mutate({
                    mutation: RETAILER_CHECKOUT_CONVERT,
                    variables: {
                        input: {
                            paymentMethod: {
                                id: this.paymentMethodId,
                            },
                        },
                    },
                })
                .then((data) => {
                    const response = data?.data?.retailerCheckoutConvert

                    this.retailerOrder = response?.retailerOrder

                    if (this.retailerOrder) {
                        this.startPayment()
                    } else {
                        this.isSubmitting = false

                        this.handleErrors(response.userErrors)
                    }
                })
        },

        startPayment() {
            this.$apollo
                .mutate({
                    mutation: RETAILER_ORDER_PAY,
                    variables: {
                        input: {
                            token: this.retailerOrder.token,
                            paymentMethod: {
                                id: this.paymentMethodId,
                            },
                        },
                    },
                })
                .then((data) => {
                    const paymentResponse = data?.data?.retailerOrderPay

                    if (
                        !paymentResponse?.success &&
                        !paymentResponse?.redirectUrl
                    ) {
                        this.isSubmitting = false

                        this.handleErrors(paymentResponse?.userErrors)

                        return
                    }

                    if (paymentResponse.redirectUrl) {
                        // Replace the current URL with the payment URL specific for the order that was just created.
                        // This makes the UX of not paying the order and going back better.
                        const paymentUrl = this.localePath({
                            name: 'order-token-payment',
                            params: {
                                token: this.retailerOrder.token,
                            },
                        })

                        history.replaceState(null, '', paymentUrl)

                        window.location.href = paymentResponse.redirectUrl
                    } else {
                        this.$router.push(
                            this.localePath({
                                name: 'order-token-confirmation',
                                params: {
                                    token: this.retailerOrder.token,
                                },
                            })
                        )
                    }
                })
        },
    },
}
